module.exports = __webpack_public_path__ + "static/media/azure-logo.44110412.png";